export type InlineCommentExperienceContext = {
	commentTargetType: 'media' | 'remixEmbed' | 'text' | 'other' | 'unknown';
	pageMode?: 'edit' | 'view' | 'live';
};

/** Read the annotated element, not the comment body or an image's URL. */
export function getInlineCommentExperienceContext(
	annotationId: string | undefined,
	pageMode?: InlineCommentExperienceContext['pageMode'],
): InlineCommentExperienceContext {
	const context: InlineCommentExperienceContext = {
		commentTargetType: 'unknown',
		...(pageMode ? { pageMode } : {}),
	};
	if (!annotationId) {
		return context;
	}
	const annotation = Array.from(
		typeof document !== 'undefined'
			? document.querySelectorAll('[data-mark-annotation-type="inlineComment"][data-id]')
			: [],
	).find((element) => element.getAttribute('data-id') === annotationId);
	if (!annotation) {
		return context;
	}
	const blockSelector =
		'[data-node-type="extension"], [data-prosemirror-node-name="extension"], ' +
		'[data-node-type="media"], [data-node-type="mediaSingle"], [data-prosemirror-node-name="mediaSingle"]';
	// Renderer anchors sit inside the block; editor annotation marks can wrap it.
	const block = annotation.closest(blockSelector) ?? annotation.querySelector(blockSelector);
	if (!block) {
		return { ...context, commentTargetType: 'text' };
	}
	const nodeType =
		block.getAttribute('data-node-type') ?? block.getAttribute('data-prosemirror-node-name');
	if (nodeType !== 'extension') {
		return { ...context, commentTargetType: 'media' };
	}
	const embed = block.querySelector('[data-native-embed-experience="maui"]');
	return {
		...context,
		commentTargetType:
			block.getAttribute('extensionkey') === 'native-embed:maui' ||
			embed?.closest(blockSelector) === block
				? 'remixEmbed'
				: 'other',
	};
}
